import { useEffect, useRef } from 'react';
import { useOrderConditionContext } from '../../../contexts/OrderCondition.context';
import { ALL_ORDER_CONDITIONS_ID } from '../../../contexts/hooks/useSelectedOrderCondition';
import { ORDER_OBJECT_TAB } from '../../../orders.constants';
import { OrderTabKey } from '../orderObjectPage.types';

const useOrderObjectTabConditionReset = (activeTab: OrderTabKey) => {
  const { orderConditions, selectCondition } = useOrderConditionContext();
  const resetTab = useRef<OrderTabKey>();
  const firstConditionId = orderConditions[0]?.id;

  useEffect(() => {
    if (resetTab.current === activeTab) {
      return;
    }

    if (activeTab === ORDER_OBJECT_TAB.PRODUCTS) {
      resetTab.current = activeTab;
      selectCondition(ALL_ORDER_CONDITIONS_ID);
      return;
    }

    if (activeTab === ORDER_OBJECT_TAB.CONDITIONS && firstConditionId) {
      resetTab.current = activeTab;
      selectCondition(firstConditionId);
    }
  }, [activeTab, firstConditionId, selectCondition]);
};

export default useOrderObjectTabConditionReset;
